import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Ride } from '../../../../shared/models/ride-history/ride.model';
import { HttpService } from '../../../../service/http/http.service';
import { DurationPipe } from '../../../../shared/pipes/duration.pipe';
import { DistanceConverterPipe } from '../../../../shared/pipes/distance-converter.pipe';
import { environment } from '@environments/environment';
import { backendRestApis } from '@environments/backend-rest-apis';
import { MiniMapComponent } from '../../../../core/map/mini-map/mini-map.component';

@Component({
  selector: 'app-last-ride-card',
  imports: [
    RouterLink,
    CommonModule,
    DurationPipe,
    DistanceConverterPipe,
    MiniMapComponent
  ],
  templateUrl: './last-ride-card.component.html',
  styleUrl: './last-ride-card.component.css'
})
/**
 * Komponenta za prikaz kartice zadnje vožnje.
 * Dohvaća zadnju spremljenu vožnju (najveći id) i prikazuje minijaturu rute,
 * udaljenost i trajanje. Klik na karticu vodi na stranicu detalja vožnje.
 */
export class LastRideCardComponent implements OnInit {

  private httpService = inject(HttpService);
  private baseUrl = `${environment.apiUrl}${backendRestApis.ride.getLastRide}`;

  lastRide = signal<Ride | null>(null);
  loading = signal<boolean>(true);

  /**
   * Inicijalizira komponentu i dohvaća zadnju vožnju.
   */
  ngOnInit(): void {
    const subscription = this.httpService.get<Ride>(this.baseUrl)
      .subscribe({
        next: (ride) => {
          this.lastRide.set(ride);
          this.loading.set(false);
        },
        error: () => {
          this.loading.set(false);
        }
      });

    this.httpService.unsubscribeWithDestroyRef(subscription);
  }
}